import React, {useState} from "react";
import "./style.scss";
import AddAddressModal from "../../AddAddressModal";
import EditAddressModal from "../../EditAddressModal";
import AddIcon from "../../../../assets/icons/add-circle-white.svg";
// import DeleteIcon from "../../../../assets/icons/DeleteIcon.svg";

import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {getUserAddress} from "../../../../utils/apis";
import LoaderOverlay from "../../../../reusableComponents/Loader";
import Select from "react-select";
import {country} from "../../../../utils/constants/country";
import customStyles, {newSelectorStyles} from "../../../../customstyle/customstyle";
import {addAddress} from "../../../../store/reducers/userSlice";
import {deleteUserAddress} from "../../../../utils/apis/user";
import ConfirmationModal from "../../../ConfirmationModal";
import {returnMessages} from "../../../../store/reducers/message";
import DeleteIcon from "@mui/icons-material/Delete";

const EditIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clip-path="url(#clip0_464_5518)">
      <path
        d="M9 2.5H14.25C14.6478 2.5 15.0294 2.65804 15.3107 2.93934C15.592 3.22064 15.75 3.60218 15.75 4V14.5C15.75 14.8978 15.592 15.2794 15.3107 15.5607C15.0294 15.842 14.6478 16 14.25 16H3.75C3.35218 16 2.97064 15.842 2.68934 15.5607C2.40804 15.2794 2.25 14.8978 2.25 14.5V9.25"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.21875 2.21794C3.92038 1.91957 3.51571 1.75195 3.09375 1.75195C2.67179 1.75195 2.26712 1.91957 1.96875 2.21794C1.67038 2.51631 1.50276 2.92099 1.50276 3.34294C1.50276 3.7649 1.67038 4.16957 1.96875 4.46794L9 11.4992L12 12.2492L11.25 9.24919L4.21875 2.21794Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_464_5518">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="matrix(-1 0 0 1 18 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);
const EditIconAfter = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clip-path="url(#clip0_464_7300)">
      <path
        d="M9 2.5H14.25C14.6478 2.5 15.0294 2.65804 15.3107 2.93934C15.592 3.22064 15.75 3.60218 15.75 4V14.5C15.75 14.8978 15.592 15.2794 15.3107 15.5607C15.0294 15.842 14.6478 16 14.25 16H3.75C3.35218 16 2.97064 15.842 2.68934 15.5607C2.40804 15.2794 2.25 14.8978 2.25 14.5V9.25"
        stroke="#121212"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.21875 2.21794C3.92038 1.91957 3.51571 1.75195 3.09375 1.75195C2.67179 1.75195 2.26712 1.91957 1.96875 2.21794C1.67038 2.51631 1.50276 2.92099 1.50276 3.34294C1.50276 3.7649 1.67038 4.16957 1.96875 4.46794L9 11.4992L12 12.2492L11.25 9.24919L4.21875 2.21794Z"
        stroke="#121212"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_464_7300">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="matrix(-1 0 0 1 18 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);
function InvoiceDetails({data, selectedAddress, variant = 1, setSelectedAddress, formData, setFormData}) {
  const [isLoading, setIsLoading] = useState(false);
  const idToken = useSelector((state) => state.auth.idToken);
  const [userAddress, setUserAddress] = useState([]);
  const [activeAddress, setActiveAddress] = useState(false);

  const dispatch = useDispatch();

  const fetchData = async () => {
    setIsLoading(true);
    const data = await getUserAddress(idToken);
    setUserAddress(data);
    dispatch(addAddress(data));
    setSelectedAddress(data[0]?.id || null);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const [isAddAddressModalOpen, setIsAddAddressModalOpen] = useState(false);

  const [isEditAddressModalOpen, setIsEditAddressModalOpen] = useState(false);

  const [addressId, setaddressId] = useState();
  const [idx, setIdx] = useState(null);

  const openAddAddressModal = () => {
    setIsAddAddressModalOpen(true);
  };

  const closeAddAddressModal = () => {
    setIsAddAddressModalOpen(false);
  };

  const openEditAddressModal = (id, idx) => {
    setaddressId(id);
    setIdx(idx);
    setIsEditAddressModalOpen(true);
  };

  const closeEditAddressModal = () => {
    setIsEditAddressModalOpen(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const options = country.map((item) => {
    return {
      value: item.country,
      label: item.country,
    };
  });
  const userDetails = useSelector((state) => state.user);
  // const [formData, setFormData] = useState({
  //   first_name: userDetails.first_name,
  //   last_name: userDetails.last_name,
  //   email: userDetails.email,
  //   country: userDetails.country,
  // });
  const [countryName, setCountryName] = useState({label: userDetails.country, value: userDetails.country});
  const handleCountryChange = (selectedOption) => {
    setCountryName(selectedOption);
    setFormData((prevData) => ({
      ...prevData,
      country: selectedOption.value,
    }));
  };

  useEffect(() => {
    setCountryName({label: userDetails.country, value: userDetails.country});
  }, [userDetails]);

  const handleChange = (e) => {
    const {name, value} = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [userDetail, setuserDetail] = useState([]);
  const userData = useSelector((state) => state.user);
  useEffect(() => {
    setuserDetail(userData);
  }, [userData]);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleDeleteAddress = async (e) => {
    // If 'e' is an event object (e.g., from a form or button), prevent default behavior
    if (e?.preventDefault) {
      e.preventDefault();
    }

    try {
      const response = await deleteUserAddress(idToken, isConfirmed);
      console.log("Delete response:", response);
      if (response?.status) {
        dispatch(returnMessages("Address deleted successfully", 200));
      }
      fetchData();

      // More descriptive logging
      // Optionally: Add success handling (e.g., update UI, show a message)
      return response; // If the caller needs the response
    } catch (error) {
      console.error("Error deleting address:", error); // Log the error for debugging
      // Optionally: Handle the error (e.g., show an error message to the user)
      throw error; // Re-throw if the caller needs to handle it
    }
  };
  const handleDeleteSubmit = async (e) => {
    setIsConfirmed(e);
  };

  return (
    <>
      {isConfirmed && (
        <ConfirmationModal
          id={""}
          onConfirm={handleDeleteAddress}
          setConfirmationModal={setIsConfirmed}
        />
      )}
      <div className="invoicedetails">
        {isLoading && <LoaderOverlay />}
        <div className="invoicedetails_header">
          <h4>Invoice Details</h4>
          <div
            className="add_address_btn"
            onClick={openAddAddressModal}
          >
            <img
              src={AddIcon}
              alt="plus icon"
            />
            <p>Add New Address</p>
          </div>
        </div>

        <div className="address_containers">
          {variant !== 2 ? (
            <>
              {userAddress?.length > 0 && (
                <>
                  {(() => {
                    const addressContainers = [];
                    for (let i = 0; i < userAddress.length; i++) {
                      addressContainers.push(
                        <AddressContainer
                          setSelectedAddress={setSelectedAddress}
                          selectedAddress={selectedAddress}
                          key={i}
                          data={userAddress[i]}
                          openEditAddressModal={openEditAddressModal}
                          idx={i}
                          setActiveAddress={setActiveAddress}
                          activeAddress={activeAddress}
                          handleDeleteAddress={handleDeleteSubmit}
                        />,
                      );
                    }
                    return addressContainers;
                  })()}
                </>
              )}
            </>
          ) : (
            <>
              {userAddress?.length > 0 && (
                <>
                  {(() => {
                    const addressContainers = [];
                    for (let i = 0; i < userAddress.length; i++) {
                      addressContainers.push(
                        <AddressContainer2
                          setSelectedAddress={setSelectedAddress}
                          selectedAddress={selectedAddress}
                          key={i}
                          data={userAddress[i]}
                          openEditAddressModal={openEditAddressModal}
                          idx={i}
                          setActiveAddress={setActiveAddress}
                          activeAddress={activeAddress}
                          handleDeleteAddress={handleDeleteSubmit}
                        />,
                      );
                    }
                    return addressContainers;
                  })()}
                </>
              )}
            </>
          )}
          {/* <div className="account_input">
            <label
              htmlFor="firstName"
              className="label_black"
            >
              First Name
            </label>
            <br />
            <div className={`account_input_wrapper `}>
              <input
                disabled={userDetail?.first_name?.trim() !== ""}
                className="account_details_input"
                type="text"
                value={formData.first_name}
                placeholder="First Name"
                name="first_name"
                required
                onChange={handleChange}
                // disabled={editMode}
              />
            </div>
          </div>
          <div className="account_input">
            <label htmlFor="lastName">Last Name</label>
            <br />
            <div className={`account_input_wrapper`}>
              <input
                disabled={userDetail?.last_name?.trim() !== ""}
                className="account_details_input"
                type="text"
                placeholder="Last Name"
                value={formData.last_name}
                name="last_name"
                onChange={handleChange}
                // disabled={editMode}
              />
            </div>
          </div> */}
          {/* <div className="account_input">
            <label htmlFor="lastName">Email</label>
            <br />
            <div className={`account_input_wrapper`}>
              <input
                disabled={userDetail?.email?.trim() !== ""}
                className="account_details_input"
                type="text"
                placeholder="Email Address"
                value={formData.email}
                name="email"
                required
                onChange={handleChange}
                // disabled={editMode}
              />
            </div>
          </div> */}
          {/* <div className="account_input country_selector">
            <label htmlFor="country">Country</label>
            <br />
            <div className={`account_input_wrapper country `}>
              <Select
                isSearchable={true}
                className="react-select-container"
                classNamePrefix="react-select"
                options={options}
                styles={newSelectorStyles}
                value={countryName}
                onChange={handleCountryChange}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: () => null,
                }}
                name="selectedCountry"
                id="country"
                isDisabled={userDetail?.country !== null && userDetail?.country?.trim() !== ""}
              />
            </div>
          </div> */}
        </div>
      </div>

      {isAddAddressModalOpen ? (
        <div className="modal">
          <div className="modal_overlay">
            <AddAddressModal
              closeAddAddressModal={closeAddAddressModal}
              fetchData={fetchData}
            />
          </div>{" "}
        </div>
      ) : null}

      {isEditAddressModalOpen ? (
        <div className="modal">
          <div className="modal_overlay">
            <EditAddressModal
              addressId={addressId}
              data={userAddress[idx]}
              setUserAddress={setUserAddress}
              closeEditAddressModal={closeEditAddressModal}
            />
          </div>
        </div>
      ) : null}
    </>
  );
}

export default InvoiceDetails;

const AddressContainer = ({openEditAddressModal, data, idx, selectedAddress, setSelectedAddress, handleDeleteAddress}) => {
  const user = useSelector((state) => state.user);

  const {first_name, last_name, email, contact, country_code} = user;

  return (
    <div
      className={`address_container ${selectedAddress === data.id && "active_address"}`}
      onClick={() => (setSelectedAddress ? setSelectedAddress(data.id) : null)}
    >
      <div className="addressInnerDetails">
        <div className="address_container_header">
          <h2>
            {data?.first_name} {data?.last_name}
          </h2>
        </div>

        <div className={`address_container_details ${selectedAddress === data.id && "active_address"}`}>
          <div className="innerContainerAddress">
            <div className="address_container_details_left">
              <p>{data?.email}</p>
              {/* <p>{data?.number}</p> */}
              <p>
                {/* {country_code} */}
                {data?.number}
              </p>
            </div>
            <div className="address_container_details_right">
              <p>
                {data?.apartment_no} <br></br>
                {data?.street_address} {data?.city} {data?.zip_code}
                <br></br>
                {data?.country}
              </p>
            </div>
          </div>

          {/*--------------------------------------------------------------- button */}
          <div style={{display: "flex", alignItems: "center", gap: "20px"}}>
            <div
              onClick={() => openEditAddressModal(data.id, idx)}
              className="address_container_header_right"
            >
              {selectedAddress === data.id && "active_address" ? EditIconAfter : EditIcon}
              <p>Edit </p>
            </div>
            <div
              onClick={() => handleDeleteAddress(data.id)}
              className="address_container_header_delete"
            >
              <DeleteIcon sx={{color: "red"}} />{" "}
            </div>
          </div>
        </div>
      </div>

      <div className="address_container_header_left">
        <input
          disabled
          type="radio"
          id="radio_button"
          name="radio-address-group"
          style={{accentColor: selectedAddress === data.id ? "red" : ""}}
          checked={selectedAddress === data.id}
          // onClick={(e) => setActiveAddress(e.target.checked ? true : false)}
        />
        <p>{data?.name}</p>
      </div>
    </div>
  );
};

const AddressContainer2 = ({openEditAddressModal, data, idx, selectedAddress, handleDeleteAddress, setSelectedAddress}) => {
  const user = useSelector((state) => state.user);

  const {first_name, last_name, email, contact, country_code} = user;

  return (
    <div
      className={`address_container2 ${selectedAddress === data.id && "active_address2"}`}
      onClick={() => (setSelectedAddress ? setSelectedAddress(data.id) : null)}
    >
      <div className="address_container_header2">
        <div className="item">
          <p>Name</p>
          <h4>
            {data?.first_name} {data?.last_name}
          </h4>
        </div>

        <div className="item">
          <p>Email</p>
          <h4>{data?.email}</h4>
        </div>

        {/* <div className="address_container_header_left2">
          <input
            disabled
            type="radio"
            id="radio_button"
            name="radio-address-group"
            style={{ accentColor: selectedAddress === data.id ? "red" : "" }}
            checked={selectedAddress === data.id}
          // onClick={(e) => setActiveAddress(e.target.checked ? true : false)}
          />
          <p>{data?.name}</p>
        </div> */}
      </div>

      <div className="address_container_details2">
        <div className="item">
          <p>Phone No</p>
          <h4>{data.number}</h4>
        </div>

        <div className="item">
          <p>Address</p>
          <h4>
            {" "}
            {data?.apartment_no} <br></br>
            {data?.street_address} {data?.city} {data?.state} {data?.zip_code}
            <br></br>
            {data?.country}
          </h4>
        </div>
      </div>

      <div className={`address_container_edit`}>
        {selectedAddress === data.id && <span>Default Address</span>}
        <div
          onClick={() => openEditAddressModal(data.id, idx)}
          className="address_container_edit_wrapper"
        >
          {EditIcon}
        </div>
        <div
          onClick={() => handleDeleteAddress(data.id)}
          className="address_container_edit_wrapper delete"
        >
          <DeleteIcon sx={{color: "red"}} />
        </div>
      </div>
    </div>
  );
};
